import { captureException } from '@sentry/react'
import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { useLocation } from 'react-router-dom'

import { sendEvent } from '~/api/events'
import { COOKIES } from '~/const'

const usePageViewEvent = (): void => {
  const [cookies] = useCookies([COOKIES.TOKENS])

  const location = useLocation()

  const url = new URL(window.location.href)

  const queryParams = new URLSearchParams(url.search)

  const [prevPathname, setPrevPathname] = useState(location.pathname)

  const [prevQueryParams, setPrevQueryParams] = useState<URLSearchParams>(queryParams)

  useEffect(() => {
    const url = new URL(window.location.href)
    const queryParams = new URLSearchParams(url.search)

    if (queryParams.toString() !== prevQueryParams.toString() || location.pathname !== prevPathname) {
      setPrevPathname(location.pathname)
      setPrevQueryParams(queryParams)
    }
  }, [location, prevPathname, prevQueryParams])

  useEffect(() => {
    async function sendPageViewEvent() {
      try {
        const formattedPageName = prevPathname.split('/').slice(1).join('#')

        await sendEvent({
          eventType: 'page_view',
          value: {
            full_url: window.location.href,
            page: !formattedPageName.length ? 'home' : formattedPageName,
            page_url: prevPathname,
            query_params: prevQueryParams ? Object.fromEntries(prevQueryParams) : {},
          },
        })
      } catch (e) {
        captureException(e)
      }
    }

    if (cookies[COOKIES.TOKENS]) sendPageViewEvent()
  }, [cookies, prevPathname, prevQueryParams])
}

export default usePageViewEvent
